export const getDashboardFilterValue = (filters, key, defaultValue = null) => {
  if (filters?.[key]) {
    return filters[key]
  }
  return defaultValue
}
